<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Editar Aplicación</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.name"
                  label="Nombre"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.url"
                  :rules="urlRules"
                  label="URL"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="editedItem.description"
                  name="description"
                  label="Descripción"
                  :rules="descriptionRules"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-switch v-model="editedItem.active" label="Estado"></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue"
          :loading="isLoading"
          :disabled="isLoading"
          text
          @click="save()"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { isUrl, isRequired, maxlength } from "@/assets/js/validations";
import { $EventBus } from "@/main";
export default {
  name: "EditApplicationDialog",

  props: {
    application: Object,
  },

  data: () => ({
    isValidFormDialog: false,
    nameRules: [(v) => isRequired(v), (v) => maxlength(v, 255)],
    descriptionRules: [(v) => isRequired(v), (v) => maxlength(v, 500)],
    urlRules: [(v) => isRequired(v), (v) => isUrl(v)],
    dialog: false,
    isLoading: false,
    editedItem: {
      name: "",
      url: "",
      description: "",
      active: null,
    },
    defaultItem: {
      name: "",
      url: "",
      description: "",
      active: null,
    },
  }),

  computed: {
    applications() {
      return this.$store.getters["applications/getApplicationsList"];
    },
    modules() {
      return this.$store.getters["modules/getModulesList"];
    },
    pages() {
      return this.$store.getters["pages/getPagesList"];
    },
    validationErrors() {
      return this.$store.getters["applications/getValidationErrors"];
    },
  },

  watch: {
    application(val) {
      if (val && val.name) {
        this.dialog = true;
        this.editedItem = val;
      }
    },
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("applications/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await this.$store.dispatch(
            "applications/updateApplication",
            this.editedItem
          );
          this.showSnack("green", "Aplicación actualizada");
          this.$emit("resetFilter");
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
